import { Box } from '@mui/material'
import { BaseSelect, useGestioneElenchi } from '@lucan/base-ui'
import { LINGUE } from 'context/LinguaProvider'
import { useAppContext } from 'GlobalContext'

export default function SceltaLingua(props) {
  const { lingue, ...rest } = props

  //const setLingua = useLinguaSetter() // setter del contesto superiore
  //const lingua = useLinguaValue() 
  const { setLingua, lingua } = useAppContext()

  const { invalidaElenchiTutti } = useGestioneElenchi()

  return (
    <Box {...rest}>
      <BaseSelect
        value={lingua}
        onChange={e => {
          setLingua(e.target.value)
          setTimeout(() => invalidaElenchiTutti(), 1000)
        }}
        options={LINGUE.filter(({ value }) => lingue.includes(value))}
      />
    </Box>
  )
}